<div class="period-range-picker">
  <!-- Filter Type Selector -->
  <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'" class="period-type-field">
    <mat-label>Period Type</mat-label>
    <mat-select [(value)]="periodType" (selectionChange)="onPeriodTypeChange()" [disabled]="disabled">
      <mat-option value="ytd">Year to Date (YTD)</mat-option>
      <mat-option value="monthly">Monthly</mat-option>
      <mat-option value="quarterly">Quarterly</mat-option>
      <mat-option value="yearly">Yearly</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Period Range Input Field with Dropdown -->
  <div class="period-range-container">
    <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'" class="period-range-field" (click)="openPicker()">
      <mat-label>Select period range</mat-label>
      <input matInput [value]="rangeDisplay" readonly [disabled]="periodType === 'ytd'">
      <mat-icon matSuffix>calendar_today</mat-icon>
    </mat-form-field>

    <!-- Custom Picker Dropdown -->
    @if (pickerOpen) {
      <div class="picker-backdrop" (click)="closePicker()"></div>
      <div class="picker-dropdown" 
           [class.position-below]="dropdownPosition === 'below'"
           [class.position-above]="dropdownPosition === 'above'">
      <div class="picker-header">
        <button mat-icon-button (click)="previousYear()">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="picker-title">{{ currentViewYear }}</span>
        <button mat-icon-button (click)="nextYear()">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>

      <div class="picker-content">
        <!-- YTD View -->
        @if (periodType === 'ytd') {
          <div class="ytd-display">
            <p>Year to Date (Last year today till yesterday)</p>
            <p class="ytd-range">{{ ytdRangeDisplay }}</p>
          </div>
        }

          <!-- Monthly View -->
          @if (periodType === 'monthly') {
            <div class="month-grid">
              @for (month of months; track month.value) {
                <button 
                  class="period-button"
                  [class.selected]="isMonthSelected(currentViewYear, month.value)"
                  [class.in-range]="isMonthInRange(currentViewYear, month.value)"
                  [class.range-start]="isRangeStart(currentViewYear, month.value, 'monthly')"
                  [class.range-end]="isRangeEnd(currentViewYear, month.value, 'monthly')"
                  [disabled]="isMonthDisabled(currentViewYear, month.value)"
                  (click)="selectMonth(currentViewYear, month.value)"
                  mat-stroked-button>
                  {{ month.short }}
                </button>
              }
            </div>
          }        <!-- Quarterly View -->
        @if (periodType === 'quarterly') {
          <div class="quarter-grid">
            @for (quarter of quarters; track quarter.value) {
              <button 
                class="period-button quarter-button"
                [class.selected]="isQuarterSelected(currentViewYear, quarter.value)"
                [class.in-range]="isQuarterInRange(currentViewYear, quarter.value)"
                [class.range-start]="isRangeStart(currentViewYear, quarter.value, 'quarterly')"
                [class.range-end]="isRangeEnd(currentViewYear, quarter.value, 'quarterly')"
                [disabled]="isQuarterDisabled(currentViewYear, quarter.value)"
                (click)="selectQuarter(currentViewYear, quarter.value)"
                mat-stroked-button>
                <div class="quarter-label">{{ quarter.label }}</div>
                <div class="quarter-months">{{ quarter.months }}</div>
              </button>
            }
          </div>
        }

        <!-- Yearly View -->
        @if (periodType === 'yearly') {
          <div class="year-grid">
            @for (year of yearRange; track year) {
              <button 
                class="period-button year-button"
                [class.selected]="isYearSelected(year)"
                [class.in-range]="isYearInRange(year)"
                [class.range-start]="isRangeStart(year, 0, 'yearly')"
                [class.range-end]="isRangeEnd(year, 0, 'yearly')"
                [disabled]="isYearDisabled(year)"
                (click)="selectYear(year)"
                mat-stroked-button>
                {{ year }}
              </button>
            }
          </div>
        }
      </div>

      <div class="picker-actions">
        <button mat-button (click)="clearSelection()">Clear</button>
        <button mat-button (click)="closePicker()">Close</button>
      </div>
    </div>
    }
  </div>
</div>
